import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { saleSetApi } from "../../../api/saleSet/saleSetApi";
import { ISaleSet } from "../../../model/respone/sale-set/ISaleSet";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { eSaleSetActionTypeIds, ISaleSetActions } from "../../action-types/sale-set/ISaleSetActionType";

const mainAction = rootActions.saleSet.saleSet;

export function* saleSetSaga(): any {
    yield takeLatest(eSaleSetActionTypeIds.LOAD_START, loadWorker);
    yield takeEvery(eSaleSetActionTypeIds.SAVE_START, saveWorker);
    yield takeEvery(eSaleSetActionTypeIds.DELETE_START, deleteWorker);
    yield takeLatest(eSaleSetActionTypeIds.LOAD_BY_HOCSINH_START, loadByHocSinhWorker);
}

function* loadWorker(): any {
    const res: IBaseRespone = yield call(saleSetApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: ISaleSetActions): any {
    let res: IBaseRespone;
    const saleSet = action.payload as ISaleSet;
    if (saleSet.id > 0) {
        res = yield call(saleSetApi.Update, saleSet);
    } else {
        res = yield call(saleSetApi.Insert, saleSet);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: ISaleSetActions): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(saleSetApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(undefined));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* loadByHocSinhWorker(action: ISaleSetActions): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(saleSetApi.SelectByHocSinh, id);
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_HOCSINH_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_BY_HOCSINH_ERROR(res.message ?? "Có lỗi"));
    }
}
